__turbopack_context__.v({
  "cardGrid": "page-module__E0kJGG__cardGrid",
  "comparisonCard": "page-module__E0kJGG__comparisonCard",
  "comparisonCardSuccess": "page-module__E0kJGG__comparisonCardSuccess",
  "comparisonCardTop": "page-module__E0kJGG__comparisonCardTop",
  "comparisonCardWarning": "page-module__E0kJGG__comparisonCardWarning",
  "comparisonGrid": "page-module__E0kJGG__comparisonGrid",
  "comparisonItemIcon": "page-module__E0kJGG__comparisonItemIcon",
  "comparisonItemIconSuccess": "page-module__E0kJGG__comparisonItemIconSuccess",
  "comparisonItemIconWarning": "page-module__E0kJGG__comparisonItemIconWarning",
  "comparisonLabel": "page-module__E0kJGG__comparisonLabel",
  "comparisonList": "page-module__E0kJGG__comparisonList",
  "comparisonTag": "page-module__E0kJGG__comparisonTag",
  "comparisonTagSuccess": "page-module__E0kJGG__comparisonTagSuccess",
  "comparisonTagWarning": "page-module__E0kJGG__comparisonTagWarning",
  "cta": "page-module__E0kJGG__cta",
  "ctaPrimary": "page-module__E0kJGG__ctaPrimary",
  "ctas": "page-module__E0kJGG__ctas",
  "featureBadge": "page-module__E0kJGG__featureBadge",
  "featureCard": "page-module__E0kJGG__featureCard",
  "hero": "page-module__E0kJGG__hero",
  "heroCopy": "page-module__E0kJGG__heroCopy",
  "heroPanel": "page-module__E0kJGG__heroPanel",
  "kicker": "page-module__E0kJGG__kicker",
  "main": "page-module__E0kJGG__main",
  "page": "page-module__E0kJGG__page",
  "planAmount": "page-module__E0kJGG__planAmount",
  "planBadge": "page-module__E0kJGG__planBadge",
  "planMeta": "page-module__E0kJGG__planMeta",
  "planPrice": "page-module__E0kJGG__planPrice",
  "planSymbol": "page-module__E0kJGG__planSymbol",
  "planTitle": "page-module__E0kJGG__planTitle",
  "previewCaption": "page-module__E0kJGG__previewCaption",
  "previewImage": "page-module__E0kJGG__previewImage",
  "previewShell": "page-module__E0kJGG__previewShell",
  "pricingBody": "page-module__E0kJGG__pricingBody",
  "pricingCard": "page-module__E0kJGG__pricingCard",
  "pricingGrid": "page-module__E0kJGG__pricingGrid",
  "pricingItem": "page-module__E0kJGG__pricingItem",
  "pricingTop": "page-module__E0kJGG__pricingTop",
  "section": "page-module__E0kJGG__section",
  "sectionIntro": "page-module__E0kJGG__sectionIntro",
  "sectionLead": "page-module__E0kJGG__sectionLead",
  "statusNo": "page-module__E0kJGG__statusNo",
  "statusYes": "page-module__E0kJGG__statusYes",
  "stepBadge": "page-module__E0kJGG__stepBadge",
  "stepCard": "page-module__E0kJGG__stepCard",
  "stepNumber": "page-module__E0kJGG__stepNumber",
  "stepTop": "page-module__E0kJGG__stepTop",
  "stepsCtaText": "page-module__E0kJGG__stepsCtaText",
  "stepsCtaWrap": "page-module__E0kJGG__stepsCtaWrap",
  "stepsGrid": "page-module__E0kJGG__stepsGrid",
  "transformationBenefit": "page-module__E0kJGG__transformationBenefit",
  "transformationBenefitRow": "page-module__E0kJGG__transformationBenefitRow",
  "transformationCta": "page-module__E0kJGG__transformationCta",
  "transformationCtaCopy": "page-module__E0kJGG__transformationCtaCopy",
  "transformationCtaSubtext": "page-module__E0kJGG__transformationCtaSubtext",
  "transformationCtaText": "page-module__E0kJGG__transformationCtaText",
  "transformationIntro": "page-module__E0kJGG__transformationIntro",
  "transformationLead": "page-module__E0kJGG__transformationLead",
  "transformationSection": "page-module__E0kJGG__transformationSection",
  "transformationShell": "page-module__E0kJGG__transformationShell",
});
